import { CommsHandler } from "@1x2network/encryption";

/** get search parameters */
const PARAMS = new URLSearchParams(window.location.search);
const path = PARAMS.get("path") || "";
/** create gateway URL from the path URL parameters */
function createGatewayURL() {
    /** what directory should be replaced with gateway */

    const replaceText = path.includes("f1x2games3/") ? "f1x2games3/" : "f1x2games/";
    /** replace the path directory with gateway */
    return path.replace(replaceText, "gateway");
}

/** create local path for engine requests */
function createLocalPath() {
    const folder = path.includes("f1x2games3/") ? "f1x2games3/" : "f1x2games/";
    return "http://localhost/" + folder + "IntegratedSlots";
}

export const COMMS_HANDLER = new CommsHandler({
    gateway: createGatewayURL(),
    target: createLocalPath(),
    headerType: "ENCODED"
});
